<template>
  <div class="w-min h-min">
    <input type="file" accept="image/*" @change="uploadImage" />
    <button
      v-if="!loading"
      type="button"
      v-bind="$attrs"
      class="flex justify-center items-center flex-col w-20 h-20 border p-2 pointer"
      @click="showFileSelector"
    >
      <img src="@/assets/icons/camera.svg" class="w-10 h-10" />
      <span class="whitespace-nowrap text-xs">
        Add image
      </span>
      <input
        ref="imageInput"
        type="file"
        name="image"
        accept="image/*"
        @change="uploadImage"
      />
    </button>
    <div
      v-if="loading"
      class="image w-20 h-20 border flex justify-center items-center overflow-hidden"
    >
      <BaseMiniSpinner />
    </div>
  </div>
</template>
<script>
import { getSignedUrl, pushFile } from "@/api/store/s3.js";
export default {
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async uploadImage(e) {
      this.loading = true;
      try {
        const file = e.target.files[0];
        const type = file.type;
        const extension = "." + file.name.split(".").pop();
        const signedUrlResponse = await getSignedUrl(type, extension);
        console.log(signedUrlResponse);
        await pushFile(signedUrlResponse, file, type);
        const resultUrl = signedUrlResponse.split("?");
        this.$emit("imageUploaded", resultUrl[0]);
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
        alert("error uploading image");
      }
    },
    showFileSelector() {
      this.$refs.imageInput.click();
    }
  }
};
</script>
<style scoped>
input[type="file"] {
  display: none;
}
.image {
  width: 80px;
  min-width: 80px;
}
</style>
